import { createContext, useContext, useEffect, type ReactNode } from 'react';
import type { DanceStyleLike } from '../../../src/constants/danceLoaders';

const DanceStyleLoaderContext = createContext<DanceStyleLike[]>([]);

// The styles of the page on screen, for loaders mounted outside the page tree
// (the page-change pill). Set by the provider below.
let currentPageStyles: DanceStyleLike[] = [];
export const getCurrentPageStyles = (): DanceStyleLike[] => currentPageStyles;

interface DanceStyleLoaderProviderProps {
  styles: DanceStyleLike[] | undefined;
  children: ReactNode;
}

// Wrap a page in this so every ThemedLoader inside it counts in the page's
// dance style (a zouk event shows boom-chick-chick) without prop drilling.
export function DanceStyleLoaderProvider({ styles, children }: DanceStyleLoaderProviderProps) {
  useEffect(() => {
    currentPageStyles = styles ?? [];
    return () => {
      currentPageStyles = [];
    };
  }, [styles]);

  return (
    <DanceStyleLoaderContext.Provider value={styles ?? []}>
      {children}
    </DanceStyleLoaderContext.Provider>
  );
}

export function useDanceStyleLoaderStyles(): DanceStyleLike[] {
  return useContext(DanceStyleLoaderContext);
}
